import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.6_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@18.19.112_@vue+compiler-sf_x4dmmpj4uunswl5hv77q656qkm/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}